import useRequest from '@/shared/composables/use-request';
import type { InfoTypes } from './../types';

class UserInfo {
	async fetchCountry(payload: InfoTypes.CountryPayload) {
		try {
			const response = await useRequest().$get('/other/country/', {
				query: payload,
			});

			if (response.status === 'error') {
				return response;
			}

			return {
				results: response.data,
			};
		} catch (error) {
			console.error(error);
		}
	}

	async fetchRegion(payload: InfoTypes.RegionPayload) {
		try {
			const response = await useRequest().$get('/other/region/', {
				query: payload,
			});

			if (response.status === 'error') {
				return response;
			}

			return {
				results: response.data,
			};
		} catch (error) {
			console.error(error);
		}
	}

	async fetchCity(payload: InfoTypes.CityPayload) {
		try {
			const response = await useRequest().$get('/other/city/', {
				query: payload,
			});

			if (response.status === 'error') {
				return response;
			}

			return {
				results: response.data,
			};
		} catch (error) {
			console.error(error);
		}
	}
}

export default new UserInfo();
